class PubSubObj {
  constructor() {
    this.events = new Map()
  }

  subscribe(event, listener) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set([]))
    }
    this.events.get(event).add(listener)
  }

  unsubscribe(event, listener) {
    if (!this.events.has(event)) return

    const listeners = this.events.get(event)
    listeners.delete(listener)

    if (listeners.size === 0) {
      this.events.delete(event)
    }
  }

  dispatch(event, data, callback) {
    if (!this.events.has(event)) {
      callback?.([])
      return
    }
    const promises = []
    const listeners = this.events.get(event)
    listeners.forEach(listener => {
      const promise = listener(data)
      promises.push(promise)
    })
    Promise.all(promises).then(results => {
      callback?.(results)
    })
  }

  clean() {
    this.events.clear()
  }
}

const pubSub = new PubSubObj()

export default pubSub
